/**
 * Where the verification-loop skill lands for each supported coding agent.
 *
 * `setup` uses the agent that is calling it (when it identifies itself) plus
 * every agent already configured in the project, so onboarding is one command
 * rather than eight. Detection is presence-based and local — nothing is
 * uploaded, nothing is probed.
 */
export const AGENT_TARGETS = [
    {
        id: 'claude',
        label: 'Claude Code',
        skillPath: '.claude/skills/justloop/SKILL.md',
        detectionPaths: ['.claude/settings.json', '.claude/settings.local.json', 'CLAUDE.md'],
        scope: 'project',
    },
    {
        id: 'codex',
        label: 'Codex CLI',
        skillPath: 'AGENTS.md.justloop',
        detectionPaths: ['AGENTS.md', '.codex/config.toml'],
        scope: 'project',
    },
    {
        id: 'cursor',
        label: 'Cursor',
        skillPath: '.cursor/rules/justloop.mdc',
        detectionPaths: ['.cursor/rules', '.cursor/mcp.json'],
        scope: 'project',
    },
    {
        id: 'cline',
        label: 'Cline',
        skillPath: '.clinerules/justloop.md',
        detectionPaths: ['.clinerules', '.cline'],
        scope: 'project',
    },
    {
        id: 'roo',
        label: 'Roo Code',
        skillPath: '.roomodes/justloop.md',
        detectionPaths: ['.roomodes', '.roo'],
        scope: 'project',
    },
    {
        id: 'windsurf',
        label: 'Windsurf',
        skillPath: '.windsurf/rules/justloop.md',
        detectionPaths: ['.windsurf', '.windsurfrules'],
        scope: 'project',
    },
    {
        id: 'antigravity',
        label: 'Antigravity',
        skillPath: '.antigravity/rules/justloop.md',
        detectionPaths: ['.antigravity'],
        scope: 'project',
    },
    {
        id: 'kiro',
        label: 'Kiro',
        skillPath: '.kiro/steering/justloop.md',
        detectionPaths: ['.kiro'],
        scope: 'project',
    },
    {
        id: 'copilot',
        label: 'GitHub Copilot',
        skillPath: '.github/copilot-instructions.md',
        detectionPaths: ['.github/copilot-instructions.md', '.github/instructions'],
        scope: 'project',
    },
    {
        id: 'pi',
        label: 'Pi Agent / DSH',
        skillPath: '.agents/skills/justloop/SKILL.md',
        detectionPaths: ['.pi', '.agents', '.pi/settings.json', 'skills-lock.json'],
        scope: 'project',
    },
];
/** Where a project-scoped skill goes in a user-level install (e.g. `~/.claude/...`). */
export const USER_SCOPE_PATHS = {
    claude: '.claude/skills/justloop/SKILL.md',
    codex: '.codex/justloop.md',
    cursor: '.cursor/rules/justloop.mdc',
    cline: '.clinerules/justloop.md',
    roo: '.roomodes/justloop.md',
    windsurf: '.windsurf/rules/justloop.md',
    antigravity: '.antigravity/rules/justloop.md',
    kiro: '.kiro/steering/justloop.md',
    copilot: '.config/github-copilot/justloop.md',
    pi: '.agents/skills/justloop/SKILL.md',
};
export const AGENT_IDS = AGENT_TARGETS.map((target) => target.id);
export function agentTarget(id) {
    const target = AGENT_TARGETS.find((candidate) => candidate.id === id);
    if (!target)
        throw new Error(`unknown agent: ${id}`);
    return target;
}
export function skillPathFor(id, scope) {
    return scope === 'user' ? USER_SCOPE_PATHS[id] : agentTarget(id).skillPath;
}
/** Skill file name conventions differ per agent; used when wrapping content. */
export function skillFormat(id) {
    if (id === 'cursor')
        return 'mdc';
    if (id === 'codex')
        return 'agents-md';
    return 'markdown';
}
//# sourceMappingURL=agents.js.map